import React, { useMemo } from "react";
import { Paper, Typography, Box, Grid, Stack, Divider } from "@mui/material";
import { Calculate } from "@mui/icons-material";
import {
  getFactorA,
  getFactorB,
  getFactorC,
  getFactorX,
} from "../../utils/storieUtils";

export default function StorieIndexCard({ formData }) {
  const stats = useMemo(() => {
    const group = formData.profilgrup || "I";
    const depthStr = formData.tesirli_derinlik;
    const numDepth = formData.kok_gel_derinlik;
    const topTex = formData.horizons?.[0]?.tekstur || "";
    const stone = formData.taslilik;
    const isCalc = formData.horizons?.some((h) => h.kirec && h.kirec !== "Yok");
    const slope = formData.egim_yuzde;
    const drain = formData.tabii_drenaj;
    const erosion = formData.su_erozyon_derecesi;
    const salt = formData.tuzluluk;
    const alk = formData.alkalilik;

    const A = getFactorA(group, depthStr, numDepth);
    const B = getFactorB(topTex, stone, isCalc);
    const C = getFactorC(slope);
    const X = getFactorX(drain, erosion, salt, alk);

    // DÜZELTİLEN KISIM BURASI:
    const calculated = (A * B * C * X) / 1000000;
    const rawIndex = calculated.toFixed(2);

    return { A, B, C, X, index: rawIndex };
  }, [formData]);

  const FactorRow = ({ label, symbol, val }) => (
    <Stack direction="row" justifyContent="space-between" mb={1}>
      <Typography variant="body2" fontWeight="500" color="text.secondary">
        {label} ({symbol})
      </Typography>
      <Typography variant="body2" fontWeight="bold">
        {val}
      </Typography>
    </Stack>
  );

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 3,
        bgcolor: "#f1f8e9",
        border: "1px solid #c5e1a5",
        height: "100%",
      }}
    >
      <Stack direction="row" spacing={1} mb={2} alignItems="center">
        <Calculate color="success" />
        <Typography variant="h6" fontWeight="bold" color="success.dark">
          TOPRAK İNDEKSİ (İ)
        </Typography>
      </Stack>
      <Grid container spacing={2}>
        <Grid
          item
          xs={5}
          sx={{ textAlign: "center", borderRight: "1px solid #dcedc8" }}
        >
          <Typography
            variant="h3"
            fontWeight="900"
            color="success.main"
            sx={{ mt: 1 }}
          >
            {stats.index}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight="bold"
          >
            İ DEĞERİ
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Box sx={{ pl: 1 }}>
            <FactorRow label="Profil Grubu" symbol="A" val={stats.A} />
            <FactorRow label="Üst Toprak Bünyesi" symbol="B" val={stats.B} />
            <FactorRow label="Arazi Eğimi" symbol="C" val={stats.C} />
            <FactorRow label="Diğer Özellikler" symbol="X" val={stats.X} />
            <Divider sx={{ my: 1 }} />
            <Typography
              variant="caption"
              sx={{ fontStyle: "italic", color: "#666" }}
            >
              Formül: İ = (A * B * C * X) / 1.000.000
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
